import { checkLocalStorage } from "../shared/side-base";
import { initStateTablet } from "../tablet/side-tablet-initstate";
import { MovingGotoCloseTablet } from "../tablet/move/moving-goto-close-tablet";
import { MovingGotoOpenTablet } from "../tablet/move/moving-goto-open-tablet";
import { MovingGotoCloseTabletHorizonal } from "../tablet/move/moving-goto-close-tablet-horizonal";
import { MovingGotoOpenTabletHorizonal } from "../tablet/move/moving-goto-open-tablet-horizonal";
import { initTabletValue } from "../tablet/init-tablet-value";
import { handleOrientationChange } from "../tablet/tablet-orientation-change";
import { ORIENTATION_KEY_TABLET, STORAGE_KEY_TABLET } from "../shared/constant";
import { OrientationTablet, SidebarStateTablet } from "../types/index-type";




const readSidebarState = (): SidebarStateTablet | null => {
  const state = localStorage.getItem(STORAGE_KEY_TABLET);
  return state === "open" || state === "close" ? state : null;
};

const readOrientation = (): OrientationTablet | null => {
  const angle = localStorage.getItem(ORIENTATION_KEY_TABLET);
  return angle === "portrait" || angle === "landscape" ? angle : null;
};

export const tabletSidebar = (): void => {
  const {
    sidebarColumnsPortrait,
    mainColumnsPortrait,
    wholeLeftPositionOpen,
    wholeLeftPositionCloseLandscape,
    wholeLeftPositionClosePortrait,
    sidebarColumnsLandscape,
    mainColumnsLandscape,
    mainColumnsFillwidth,
  } = initTabletValue();

  checkLocalStorage();

  const sideBarMove = initStateTablet();
  const sideBarButton = sideBarMove?.sideBarButton;

  if (!(sideBarButton instanceof HTMLElement)) {
    return;
  }

  window.addEventListener("orientationchange", handleOrientationChange);

  const handleClick = () => {
    const sideStatus = readSidebarState();
    const angle = readOrientation();

    if (sideStatus === "open" && angle === "portrait") {
      MovingGotoCloseTablet({
        wholeLeftPositionClosePortrait,
        sidebarColumnsPortrait,
        mainColumnsFillwidth,
      });
      return;
    }

    if (sideStatus === "close" && angle === "portrait") {
      MovingGotoOpenTablet({
        wholeLeftPositionOpen,
        sidebarColumnsPortrait,
        mainColumnsPortrait,
      });
      return;
    }

    if (sideStatus === "open" && angle === "landscape") {
      MovingGotoCloseTabletHorizonal({
        wholeLeftPositionCloseLandscape,
        sidebarColumnsLandscape,
        mainColumnsFillwidth,
      });
      return;
    }

    if (sideStatus === "close" && angle === "landscape") {
      MovingGotoOpenTabletHorizonal({
        wholeLeftPositionOpen,
        sidebarColumnsLandscape,
        mainColumnsLandscape,
      });
    }
  };

  sideBarButton.addEventListener("click", handleClick);
};
